import React, { useEffect, useState } from 'react'
import { withAuth } from '../AuthContext'
import { withRouter } from 'react-router-dom'
import { loadStripe } from '@stripe/stripe-js'
import { setSubscriptionPricing, getCurrencySign } from '../../utils/utils'
import { shouldTranslateTo } from '../../utils/utils'
import { gaEvents } from '../../analytics/events'
import { SUCCESS } from '../../utils/constants'
import Notification from '../Utils/Notification'
import Error from '../Utils/Error'
import verifyAccountStatus from '../Hooks/VerifyAccountStatus'
import Payment from 'payment'
import Cookies from 'universal-cookie'
import styled from 'styled-components'
import Cards from 'react-credit-cards-2'
import 'react-credit-cards-2/dist/es/styles-compiled.css'
import { scrollIntoView } from '../Hooks/ScrollView'

import {
  Title,
  Subtitle,
  Input,
  ActionButtons,
  LoadingButton,
} from '../Utils/CustomClasses'

const stripeKey = window.location.origin.includes('localhost')
  ? 'pk_test_518KDziCpZYiw17LY2MYtYdH9etP4Z0M0sHGKsoHMy7x7uavW3cN8mfpTEgiZPwGSc0rx32ZDCMv9g1E4JJmBCq1S00ASeexo7s'
  : 'pk_live_518KDziCpZYiw17LYRTUhBuTjHhAESPtj5SDtaZNXYYmco9GYuTcuNvErxtdJgzOnSpDaTmZn9xY7pTIwfQiAhipy004T59e1Mj'
const stripePromise = loadStripe(stripeKey)
const cookies = new Cookies()

const ContainerBox = styled.div`
  padding: 0 36px 55px 36px;
  background-color: transparent;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const OnboardingTitle = styled(Title)`
  font-family: 'Open Sans', sans-serif;
`

const OnboardingSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;

  span {
    color: #ff9900;
    font-family: 'Open Sans', sans-serif;
    font-size: 40px;
    font-weight: 700;
    margin: 0 0 0 4px;
  }
`

const PriceTitle = styled(Subtitle)`
  span {
    color: #0bac5d;
    font-family: 'Open Sans', sans-serif;
    font-size: 40px;
    font-weight: 700;
    margin: 0 0 0 4px;
  }
`

const DashLineBox = styled.div`
  margin: 40px 10vw;
  padding: 30px 15px 40px;
  border-radius: 4px;
  border: 2px dashed #0bac5d;

  form {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
    gap: 10px;
    text-align: center;

    img {
      margin: 60px auto 40px;
    }
  }

  @media screen and (max-width: 600px) {
    padding: 30px 5px 40px;
  }

  @media screen and (max-width: 799px) {
    margin: 40px 0;
  }
`

const SplitRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > div {
    flex-basis: 50%;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`

const SplitColumn = styled.div`
  & > h1 {
    margin: 8px 0 0 0;
  }

  @media screen and (max-width: 768px) {
    & > h1 {
      margin: 13px 0 0 0;
    }
  }

  @media screen and (max-width: 600px) {
    text-align: center;
  }
`

const SplitColumnRight = styled(SplitColumn)`
  text-align: right;

  @media screen and (max-width: 600px) {
    text-align: center;
    h2 {
      margin-top: 20px;
    }
  }
`

const FormFields = styled.div`
  width: 80%;
  margin: 30px 0 0 0;
  min-width: 220px;
  max-width: 490px;
  text-align: left;
`

const FeeCards = styled.div`
  @media screen and (max-width: 398px) {
    display: none !important;
  }
`

const FeeActionButton = styled(ActionButtons)`
  display: inline-block;
`

const FeeLoadingButton = styled(LoadingButton)`
  display: inline-flex;
`

const BackButton = styled(ActionButtons)`
  background-color: #fff;
  border: 1px solid #000;
  color: #000;
  display: inline-block;

  @media screen and (max-width: 768px) {
    margin: 10px 0 0;
  }

  @media screen and (min-width: 769px) {
    max-width: 150px;
  }
`

const PriceChoiceBox = styled.div`
  background-color: transparent;
  border-radius: 10px;
  /*
  box-shadow: 0 5px 9px -2px #b5b5b5;
  border: 1px solid #eee;
  */
  margin: 40px 0 0;
  width: 100%;
`

const FlexRowPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 50px;
  align-items: top;
  justify-content: left;
  margin: 10px auto;
  width: 720px;

  @media (max-width: 799px) {
    flex-direction: column;
    margin-top: 20px;
    width: auto;

    & > div {
      width: -webkit-fill-available;
    }
  }
`

const PriceBoxHeaderBadgeContainer = styled.div`
  flex-basis: 33.33%;
  position: relative;
`

const PriceBoxHeaderBadge = styled.div`
  background-color: #9b0000;
  border-radius: 50%;
  height: 60px;
  width: 60px;
  position: absolute;
  top: -13px;
  right: -19px;
`

const PriceHeaderSubtitle = styled(Subtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
  text-transform: capitalize;
`

const PriceHeaderBadgeSubtitle = styled(PriceHeaderSubtitle)`
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 126%;
  margin: 14px 0 0;
`

const PriceBox = styled.div`
  background-color: #fff;
  border-radius: 10px;
  overflow: hidden;
  min-height: 300px;
  min-width: 230px;
  flex-basis: 33.33%;
`

const PriceBoxHeader = styled.div`
  background-color: #000a84;
  padding: 6px;
`

const PriceBoxPrice = styled.div`
  border-bottom: 1px solid #a5a5a5;
  align-items: center;
  justify-content: center;
`

const PriceContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin: 18px auto 34px;
  width: 170px;
  position: relative;
`

const PriceSubtitle = styled(Subtitle)`
  color: #000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  margin: 0 16px 0 0;

  @media (max-width: 799px) {
    font-size: 50px !important;
  }
`

const PriceSubtitleNoStrikePrice = styled(PriceSubtitle)`
  margin: -9px 16px 0 0;
`

const PriceSubtitleStrike = styled(Subtitle)`
  color: #ff0000;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  letter-spacing: -1px;
  font-size: 20px;
  text-decoration: line-through;
  width: 100%;
`

const PriceSubtitleNoStrike = styled(PriceSubtitleStrike)`
  text-decoration: none;
`

const PriceSubtitleNoStrikeSub = styled(PriceSubtitleNoStrike)`
  color: #6a6a6a;
  font-weight: 400;
  font-size: 13px;
  margin: 9px 0 0 0;
  width: 100%;
`

const CurrencySubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-size: 23px;
  font-weight: 400;
  margin: -36px 4px 0 0;
`

const CurrencySubtitleNoStrike = styled(CurrencySubtitle)`
  margin: -46px 4px 0 0;
`

const PriceDurationSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  color: #6a6a6a;
  font-weight: 400;
  letter-spacing: 0px;
  margin: 0 0 0 2px;
  text-transform: uppercase;

  @media (max-width: 799px) {
    font-size: 14px !important;
  }
`

const PriceBoxInfo = styled.div`
  padding: 20px;
  align-items: center;
  justify-content: center;
`

const PriceInfoSubtitle = styled(Subtitle)`
  color: #5a5a5a;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  letter-spacing: 0px;
  margin: 0 auto 30px auto;
  width: 183px;

  b {
    color: #06944d;
    font-weight: 700;
  }

  span {
    color: #ff0000;
    font-weight: 700;
    text-decoration: line-through;
  }

  @media (max-width: 799px) {
    font-size: 17px !important;
    width: 210px;
  }
`

const InfoBox = styled.div`
  flex-basis: 66.66%;

  @media (max-width: 799px) {
    text-align: center;
  }
`

const PriceChoiceTitle = styled(Subtitle)`
  @media (max-width: 799px) {
    font-size: 22px !important;
  }
`

const PriceChoiceSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-weight: 200;
  margin: 24px 20px 30px 0;

  span {
    text-transform: capitalize;
  }

  @media (max-width: 799px) {
    font-size: 18px !important;
  }
`

const FlexRowDiscount = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: flex-start;
  justify-content: flex-start;
  font-size: 16px;
`

const DiscountSubtitle = styled(Subtitle)`
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  margin: 24px 20px 8px 0;

  @media (max-width: 799px) {
    font-size: 18px !important;
  }
`

const PriceBoxList = styled.ul`
  margin: 30px 1vw 40px;

  @media screen and (max-width: 799px) {
    margin: 0 7vw 40px;
  }
`

const PblI = styled.li`
  color: #fff;
  margin: 0 0 24px 20px;
  position: relative;
  text-align: left;

  &::before {
    content: url('images/onboarding/tick-green.svg');
    font-size: 20px;
    position: absolute;
    left: -30px;
    width: 24px;
  }
`

const FeeSubscriptionOnboarding = ({
  data,
  onComplete,
  onBack,
  iAminSubscriptionFormPanel,
  setIAminSubscriptionFormPanel,
  isCopiedInSubFormPanel,
  setIsCopiedInSubFormPanel,
}) => {
  const [name, setName] = useState('')
  const [number, setNumber] = useState('')
  const [expiry, setExpiry] = useState('')
  const [cvc, setCvc] = useState('')
  const [focused, setFocused] = useState('')
  const [errorText, setErrorText] = useState('')
  const [warningText, setWarningText] = useState('')
  const [nameError, setNameError] = useState('')
  const [expiryError, setExpiryError] = useState('')
  const [cvcError, setCvcError] = useState('')
  const [loading, setLoading] = useState('')
  const [responseMessage, setResponseMessage] = useState('')
  const [membership, setMembership] = useState({
    membershipFee: null,
    membershipFeeStatus: null,
    slug: '',
  })
  const [currencySign, setCurrencySign] = useState('')
  const [pageText, setPageText] = useState([])
  const [pageText2, setPageText2] = useState([])
  const [membershipFee, setMembershipFee] = useState('47.90')
  const [discountMembershipFee, setDiscountMembershipFee] = useState('47.90')
  const [subscriptionType, setSubscriptionType] = useState('annual')
  const [displayChoice, setDisplayChoice] = useState(0)
  const [discount, setDiscount] = useState(false)
  const [discounted, setDiscounted] = useState(false)
  const [subscriptionDisplay, setSubscriptionDisplay] = useState([])
  const [subscriptionDisplayLong, setSubscriptionDisplayLong] = useState([])
  const [membershipFees, setMembershipFees] = useState([
    4.99, 19.9, 29.9, 44.99,
  ])
  const [discountType, setDiscountType] = useState(null)

  // useEffect(()=>{
  //   console.log("subscription");
  // },[isCopied]);

  useEffect(() => {
    setIAminSubscriptionFormPanel(true)
  }, [])

  /*
     move back a page when code has been copied
  */

  useEffect(() => {
    if (
      isCopiedInSubFormPanel === true &&
      iAminSubscriptionFormPanel === true
    ) {
      console.log('in the page and copied on formpage')
      setIsCopiedInSubFormPanel(false)
      setIAminSubscriptionFormPanel(false)
      console.log('out of the page and copied on formpage')
      onBack()
    }
  }, [
    iAminSubscriptionFormPanel,
    isCopiedInSubFormPanel,
    setIsCopiedInSubFormPanel,
  ])

  useEffect(() => {
    gaEvents.eventGeneric(
      'page_load',
      'stripe-page-loaded',
      data.auth.user.id + ' - stripe - page loaded'
    )

    console.log(
      'data.auth.user.subscriptionType: ' +
        JSON.stringify(cookies.get('uD').subscriptionType)
    )

    /*
        Payment.formatCardNumber(document.querySelector('[name="number"]'));
        Payment.formatCardExpiry(document.querySelector('[name="expiry"]'));
        Payment.formatCardCVC(document.querySelector('[name="cvc"]'));
        */
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          if (pageValue === 'profile-pay') {
            const subsDisplayShort = [
              pageText[56],
              pageText[25],
              pageText[28],
              pageText[33],
            ]
            const subsDisplayLong = [
              pageText[56],
              pageText[44],
              pageText[45],
              pageText[46],
            ]
            setSubscriptionDisplay(subsDisplayShort)
            setSubscriptionDisplayLong(subsDisplayLong)
          }

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const userData = cookies.get('uD')
    console.log('userData: ' + JSON.stringify(userData))

    const getPricing = async () => {
      console.log('getPricing.......')

      console.log('.... cookie cV: ' + cookies.get('cV'))

      const membershipData = await setSubscriptionPricing(
        cookies.get('uD').subscriptionType,
        cookies.get('cV'),
        'stripe'
      )

      console.log('membershipData: ' + JSON.stringify(membershipData))

      /*
      const membershipData = await setSubscriptionPricing(
        (Math.round(data.auth.user.membershipFee * 100) / 100).toFixed(2),
        data.auth.user.currencyValue,
        'stripe'
      )
      */

      /*
      const membershipData = {
        membershipFee: data.auth.user.membershipFee,
        membershipFeeStatus: data.auth.user.membershipFeeStatus,
        feeSlug: 'test_slug',
      }
      */

      setMembership(membershipData)
    }

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(
        data.auth.user.currencyValue
      )
      setCurrencySign(currencySignData.sign)
    }

    if (
      cookies.get('uD').membershipFee !== null &&
      cookies.get('uD').membershipFee !== undefined &&
      cookies.get('uD').subscriptionType !== null &&
      cookies.get('uD').subscriptionType !== undefined
    ) {
      var tDisplayChoice = 0
      if (cookies.get('uD').subscriptionType === 'annual') {
        tDisplayChoice = 3
      }
      setDisplayChoice(tDisplayChoice)

      if (cookies.get('uD').discountType) {
        setDiscounted(true)
        setDiscount(cookies.get('uD').discount)
        setDiscountMembershipFee(membershipFees[tDisplayChoice])
        setDiscountType(cookies.get('uD').discountType)
      }
      setMembershipFee(cookies.get('uD').membershipFee)
      setSubscriptionType(cookies.get('uD').subscriptionType)
    }

    getPageText('pay-as-you-choose-app', language, setPageText)
    getPageText('profile-pay', language, setPageText2)
    getPricing()
    getCurrency()
  }, [])

  const handleInputChange = ({ target }) => {
    switch (target.name) {
      case 'number':
        const v1 = target.value
          .replace(/\s+/g, '')
          .replace(/[^0-9]/gi, '')
          .substr(0, 16)
        const parts1 = []
        for (let i = 0; i < v1.length; i += 4) {
          parts1.push(v1.substr(i, 4))
        }
        setNumber(parts1.length > 1 ? parts1.join(' ') : target.value)
        break
      case 'expiry':
        const v2 = target.value
          .replace(/\s+/g, '')
          .replace(/[^0-9]/gi, '')
          .substr(0, 4)
        const parts2 = []
        for (let i = 0; i < v2.length; i += 2) {
          parts2.push(v2.substr(i, 2))
        }
        setExpiry(parts2.length > 1 ? parts2.join('/') : target.value)
        break
      case 'name':
        setName(target.value)
        break
      case 'cvc':
        setCvc(target.value)
        break
    }
  }

  const handleInputFocus = ({ target }) => {
    setFocused(target.name)
  }

  const handleSubmit = () => {
    console.log('handleSubmit')
    console.log('membership: ' + JSON.stringify(membership))

    gaEvents.eventGeneric(
      'button_click',
      'stripe-payment-actioned',
      data.auth.user.id + ' - Stripe page - button - action Stripe payment'
    )

    setLoading(true)
    setErrorText('')

    const paymentDetails = {
      name: name,
      card_no: number,
      ccExpiryMonth: expiry.slice(0, 2),
      ccExpiryYear: expiry.slice(3, 5),
      cvcNumber: cvc,
      slug: membership.slug,
      type: 'subscription_membership',
    }

    console.log('paymentDetails: ' + JSON.stringify(paymentDetails))

    const headers = {
      'X-CSRF-TOKEN': window.Laravel.csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
    }

    axios
      .post('/api/payment/stripeSubscription', paymentDetails, headers)
      .then((response) => {
        console.log('response: ' + JSON.stringify(response))

        if (!response.data.success) {
          if (response.data.error == 'requires_source_action') {
            console.log('1')
            setWarningText(pageText2[60])
            sCP(stripeKey, response.data.clientSecret, this, function (_, err) {
              if (!err.error) {
                setResponseMessage(pageText[15])
                setLoading(false)

                const updatedMembership = {
                  membershipFee: membership.membershipFee,
                  membershipFeeStatus: 'completed',
                  feeSlug: membership.feeSlug,
                }
                setResponseMessage(pageText[17])
                setMembership(updatedMembership)
                data.auth.updateUser(updatedMembership).then(() => {
                  Notification({
                    type: SUCCESS,
                    message: `${pageText[18]}`,
                  })

                  //data.auth.refreshUser()

                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                  })

                  console.log('1')

                  setTimeout(function () {
                    verifyAccountStatus(data, 'feesubscription1')
                    onComplete('db2')
                  }, 1000)

                  setLoading(false)
                })
              } else {
                setErrorText(err.error.message)
                setLoading(false)
              }
            })
          } else if (response.data.error == 'incomplete') {
            setErrorText(pageText2[61])
            setLoading(false)
          } else {
            console.log('2')
            setErrorText(response.data.error)
            setLoading(false)
          }
        } else {
          setResponseMessage(pageText[16])
          setLoading(false)

          const updatedMembership = {
            membershipFee: membership.membershipFee,
            membershipFeeStatus: 'completed',
            feeSlug: membership.feeSlug,
          }

          setMembership(updatedMembership)
          data.auth.updateUser(updatedMembership).then(() => {
            Notification({
              type: SUCCESS,
              message: `${pageText[18]}`,
            })

            //data.auth.refreshUser()

            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth',
            })

            console.log('2')

            setTimeout(function () {
              verifyAccountStatus(data, 'feesubscription2')
              onComplete('db2')
            }, 1000)

            setLoading(false)
          })
        }
      })
      .catch((err) => {
        console.log(err)
        setLoading(false)
      })
  }

  const handleGoBack = (e) => {
    e.preventDefault()
    onBack()
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border onboarding-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[19]}</span>
        </div>
      </div>
    )
  }
  return (
    <ContainerBox>
      <OnboardingTitle
        center
        color="#ff9900"
        size="34px"
        sizemd="34px"
        sizesm="34px"
        margin="10px 0 0"
        dangerouslySetInnerHTML={{
          __html: `${pageText[0]}`,
        }}
      ></OnboardingTitle>
      <OnboardingSubtitle
        center
        color="#fff"
        size="20px"
        sizesm="20px"
        weight="700"
        margin="20px 0 10px"
        dangerouslySetInnerHTML={{
          __html: `${pageText2[62]}`,
        }}
      />

      <PriceChoiceBox>
        <FlexRowPrice>
          <PriceBoxHeaderBadgeContainer>
            <PriceBoxHeaderBadge>
              {' '}
              <PriceHeaderBadgeSubtitle
                center
                size="28px"
                margin="0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText2[47]}`,
                }}
              />
            </PriceBoxHeaderBadge>
            <PriceBox>
              <PriceBoxHeader>
                {' '}
                <PriceHeaderSubtitle
                  center
                  size="18px"
                  margin="0"
                  dangerouslySetInnerHTML={{
                    __html: `${subscriptionType}`,
                  }}
                />
              </PriceBoxHeader>
              <PriceBoxPrice>
                <PriceContainer>
                  {discounted ? (
                    discountType !== 'MTH' ? (
                      <>
                        <PriceSubtitleStrike
                          center
                          size="50px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${currencySign}${(Math.round(discountMembershipFee * 100) / 100).toFixed(2)}`,
                          }}
                        />
                        <CurrencySubtitle
                          center
                          size="16px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${currencySign}`,
                          }}
                        />
                        <PriceSubtitleNoStrikePrice
                          center
                          size="50px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${(Math.round(membershipFee * 100) / 100).toFixed(2)}`,
                          }}
                        />
                      </>
                    ) : (
                      <>
                        <PriceSubtitleNoStrike
                          center
                          size="50px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${discount} MONTHS FREE`,
                          }}
                        />
                        <PriceSubtitleNoStrikeSub
                          center
                          size="13px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `THEN`,
                          }}
                        />
                        <CurrencySubtitleNoStrike
                          center
                          size="16px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${currencySign}`,
                          }}
                        />
                        <PriceSubtitleNoStrikePrice
                          center
                          size="50px"
                          margin="0"
                          dangerouslySetInnerHTML={{
                            __html: `${(Math.round(discountMembershipFee * 100) / 100).toFixed(2)}`,
                          }}
                        />
                      </>
                    )
                  ) : (
                    <>
                      <CurrencySubtitle
                        center
                        size="16px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `${currencySign}`,
                        }}
                      />
                      <PriceSubtitle
                        center
                        size="50px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `${(Math.round(membershipFee * 100) / 100).toFixed(2)}`,
                        }}
                      />
                    </>
                  )}

                  {/*}
                  {discounted ? (
                    <>
                      <PriceSubtitleStrike
                        center
                        size="50px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `${currencySign}${(Math.round(discountMembershipFee * 100) / 100).toFixed(2)}`,
                        }}
                      />
                      <CurrencySubtitle
                        center
                        size="16px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `${currencySign}`,
                        }}
                      />
                      <PriceSubtitle
                        center
                        size="50px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `${(Math.round(membershipFee * 100) / 100).toFixed(2)}`,
                        }}
                      />
                    </>
                  ) : (
                    <>
                      <CurrencySubtitle
                        center
                        size="16px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `${currencySign}`,
                        }}
                      />
                      <PriceSubtitle
                        center
                        size="50px"
                        margin="0"
                        dangerouslySetInnerHTML={{
                          __html: `${(Math.round(membershipFee * 100) / 100).toFixed(2)}`,
                        }}
                      />
                    </>
                  )}
                    */}

                  <PriceDurationSubtitle
                    center
                    size="13px"
                    margin="0"
                    dangerouslySetInnerHTML={{
                      __html: `${subscriptionDisplay[displayChoice]}`,
                    }}
                  />
                </PriceContainer>
              </PriceBoxPrice>
              <PriceBoxInfo>
                {' '}
                <PriceInfoSubtitle
                  center
                  size="15px"
                  margin="0"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText2[59]}`,
                  }}
                />
              </PriceBoxInfo>
            </PriceBox>
          </PriceBoxHeaderBadgeContainer>

          <InfoBox>
            <PriceBoxList>
              <PblI
                dangerouslySetInnerHTML={{
                  __html: `${pageText2[63]}`,
                }}
              />
              <PblI
                dangerouslySetInnerHTML={{
                  __html: `${pageText2[64]}`,
                }}
              />
              <PblI
                dangerouslySetInnerHTML={{
                  __html: `${pageText2[65]}`,
                }}
              />
              <PblI
                dangerouslySetInnerHTML={{
                  __html: `${pageText2[66]}`,
                }}
              />
              <PblI
                dangerouslySetInnerHTML={{
                  __html: `${pageText2[67]}`,
                }}
              />
              <PblI
                dangerouslySetInnerHTML={{
                  __html: `${pageText2[68]}`,
                }}
              />
              <PblI
                dangerouslySetInnerHTML={{
                  __html: `${pageText2[69]}`,
                }}
              />
            </PriceBoxList>
          </InfoBox>
        </FlexRowPrice>
      </PriceChoiceBox>

      <div id="blah"></div>

      <DashLineBox>
        <form
          method="POST"
          action="/"
          name="myForm"
          aria-label="Pay fee"
          onSubmit={(e) => {
            e.preventDefault()
            handleSubmit()
            return false
          }}
        >
          <OnboardingSubtitle
            center
            color="#fff"
            size="20px"
            sizesm="20px"
            weight="700"
            margin="20px 0 10px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[12]} <span>${currencySign}${(Math.round(membershipFee * 100) / 100).toFixed(2)}</span>`,
            }}
          />

          <OnboardingSubtitle
            color="#fff"
            size="18px"
            weight="400"
            margin="10px 20vw 5px"
            marginmd="10px 10vw 5px"
            marginsm="10px 5vw 5px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[1]}`,
            }}
          />
          <img
            src="/images/onboarding/secured-by-stripe.svg"
            alt=""
            className="img-secured-by-stripe"
          />
          <FormFields>
            {' '}
            <OnboardingSubtitle
              color="#fff"
              size="22px"
              weight="400"
              margin="10px 0 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[2]}`,
              }}
            />
            <Input
              id="number"
              type="tel"
              name="number"
              //className={numberError && "error-border"}
              className={'test-class'}
              placeholder="0000 0000 0000 0000"
              value={number}
              required
              margin="0 0 20px 0"
              marginsm="0 0 10px 0"
              onChange={(e) => handleInputChange(e)}
              onFocus={(e) => handleInputFocus(e)}
            />
            <OnboardingSubtitle
              color="#fff"
              size="22px"
              weight="400"
              margin="10px 0 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[3]}`,
              }}
            />
            <Input
              id="name"
              type="text"
              name="name"
              className={nameError && 'error-border'}
              placeholder={pageText[3]}
              required
              margin="0 0 20px 0"
              marginsm="0 0 10px 0"
              onChange={(e) => handleInputChange(e)}
              onFocus={(e) => handleInputFocus(e)}
              value={name}
            />
            <OnboardingSubtitle
              color="#fff"
              size="22px"
              weight="400"
              margin="10px 0 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[4]}`,
              }}
            />
            <Input
              id="expiry"
              type="tel"
              name="expiry"
              value={expiry}
              className={expiryError && 'error-border'}
              placeholder={pageText[5]}
              required
              margin="0 0 20px 0"
              marginsm="0 0 10px 0"
              onChange={(e) => handleInputChange(e)}
              onFocus={(e) => handleInputFocus(e)}
            />
            <OnboardingSubtitle
              color="#fff"
              size="22px"
              weight="400"
              margin="10px 0 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[6]}`,
              }}
            />
            <Input
              id="cvc"
              type="tel"
              name="cvc"
              className={cvcError && 'error-border'}
              placeholder="123"
              required
              margin="0 0 20px 0"
              marginsm="0 0 10px 0"
              onChange={(e) => handleInputChange(e)}
              onFocus={(e) => handleInputFocus(e)}
            />
            {loading ? (
              <FeeLoadingButton padding="10px 40px" margin="50px 0 20px">
                {pageText[14]}
              </FeeLoadingButton>
            ) : discounted && discountType === 'MTH' ? (
              <FeeActionButton
                type="submit"
                padding="10px 40px"
                margin="50px 0 20px"
              >
                Process payment details
              </FeeActionButton>
            ) : (
              <FeeActionButton
                type="submit"
                padding="10px 40px"
                margin="50px 0 20px"
              >
                {pageText[10]}
              </FeeActionButton>
            )}
            {/*}
            <BackButton
              type="submit"
              padding="10px 40px"
              margin="30px 0 20px 12px"
              onClick={(e) => {
                handleGoBack(e)
              }}
            >
              {pageText[11]}
            </BackButton>
            */}
            {responseMessage && <div>responseMessage</div>}
            {errorText && <Error error={errorText} />}
            <img src="/images/onboarding/secured-by-stripe-mini.svg" alt="" />
          </FormFields>
        </form>
      </DashLineBox>
    </ContainerBox>
  )
}

export default withRouter(withAuth(FeeSubscriptionOnboarding))
